import React, { useState, useEffect } from "react";
import {
  ButtonContainer,
  HelperText,
  Success,
  Title,
  Warning,
  ErrorText,
} from "../../components/styled/ProcessingDocument.styled";
import Loader from "../../components/elements/Loader";
import StyledButton from "../../components/elements/StyledButton";
import { Grid, Stack } from "@mui/material";
import { BsDownload } from "react-icons/bs";
import { BsUpload } from "react-icons/bs";
import Pass from "../../components/elements/Pass";
import Fail from "../../components/elements/Fail";
import { checkStatus } from "../../services/api/processsingDocument.api";
import { downloadFile } from "../../services/api/fileUpload.js";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";

export default function ProcessingDocument({
  onNext,
  uploadId,
  setProcessingMessage,
  model,
}) {
  const [status, setStatus] = useState("processing"); // status can be processing, success or error

  const downloadFileAction = async () => {
    try {
      const downloadURL = await downloadFile({
        name: encodeURI(`${uploadId}/${uploadId}.zip`),
        bucket: "output",
      });
      saveAs(downloadURL, "data.zip");
    } catch (err) {
      toast.error("Failed to download processed data", { theme: "colored" });
    }
  };

  useEffect(() => {
    const checkUpload = async () => {
      const response = await checkStatus(uploadId);
      setStatus(response.status);
      setProcessingMessage(response.status);
    };
    const interval = setInterval(() => {
      checkUpload();
    }, 2000);
    return () => clearInterval(interval);
  }, [uploadId]);
  return (
    <div>
      <Title>Processing</Title>
      {status === "processing" && (
        <>
          <Loader />
          <Warning>{model} file in under processing, please wait</Warning>
        </>
      )}
      {status === "success" && (
        <>
          <Pass />
          <Success>Process has been successfully completed</Success>
          <HelperText>Now you can download the processed file</HelperText>
        </>
      )}
      {status === "error" && (
        <>
          <Fail />
          <ErrorText>Process encountered an error</ErrorText>
          <HelperText>
            Please check your file and try to upload again
          </HelperText>
        </>
      )}
      <ButtonContainer>
        <Grid
          container
          spacing={2}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid item xs={12} md={6} justifyContent="flex-end">
            <StyledButton
              iconLeft={<BsUpload />}
              variant={"outlined"}
              onClick={onNext}
            >
              Upload New Document
            </StyledButton>
          </Grid>
          <Grid item xs={12} md={6}>
            {status === "success" && (
              <Stack direction="row" justifyContent="end">
                <StyledButton
                  iconLeft={<BsDownload />}
                  variant={"contained"}
                  onClick={downloadFileAction}
                >
                  Download the Processed File
                </StyledButton>
              </Stack>
            )}
          </Grid>
        </Grid>
      </ButtonContainer>
    </div>
  );
}
